import { useLazyQuery, useQuery } from '@apollo/client'
import { PAGINATE_LIVES, GET_LIFE, PAGINATE_HIGH_RISK_LIVES } from '../queries/livesQueries';

// import { PAGINATE_LIVES } from 'graphql/livesQueries';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { lifeCreator } from 'state';
import { useEffect } from 'react';

const usePaginateLives = (highRisk = false) => {
	const dispatch = useDispatch();
	const { paginateLives } = bindActionCreators(lifeCreator, dispatch)

	const {
	  data,
	  loading,
	  error,
	  refetch,
	  networkStatus
	} = useQuery(highRisk ? PAGINATE_HIGH_RISK_LIVES : PAGINATE_LIVES, {
	  notifyOnNetworkStatusChange: true,
	  fetchPolicy: 'no-cache'
	});
  
	useEffect(() => {
		if (data?.paginateLives || data?.paginateHighRiskLives) {
			paginateLives(highRisk ? data.paginateHighRiskLives : data.paginateLives);
		}
	}, [data, paginateLives]);
  
	return {
	  loading,
	  error,
	  refetch,
	  networkStatus
	};
};

const useLazyPaginateLives = (highRisk = false) => {
	const dispatch = useDispatch();
	const { paginateLives } = bindActionCreators(lifeCreator, dispatch)
	
		const [query, result] = useLazyQuery(highRisk ? PAGINATE_HIGH_RISK_LIVES : PAGINATE_LIVES, {
			fetchPolicy: 'no-cache'
		});
	
		useEffect(() => {
			if (result.data?.paginateLives || result.data?.paginateHighRiskLives) {
				paginateLives(highRisk ? result.data.paginateHighRiskLives : result.data.paginateLives);
			}
		}, [result.data]);
	
		return [query, result] as const;
}

const useGetLife = (id: string) => {
	// const dispatch = useDispatch();
	// const { paginateLives } = bindActionCreators(lifeCreator, dispatch)

	return useQuery(GET_LIFE, {
		variables: {
			id
		},
		// onCompleted: (data: any) => {
		// 	paginateLives(data.paginateLives);
		// }
	});
}

export {
    usePaginateLives,
	useLazyPaginateLives,
	useGetLife
}
